// Druid pure helpers. No React, no Three.js.
//
// ── Codex (Druid, front face, updated rules) ──
//   "Tap → Play or draw a site. If this is your first turn, summon
//    Tawny here."
//
// The activated half (Tap → Summon Bruin, flip) is handled directly in
// GameBoard's `_doDruidFlip` because the flip mechanic itself involves
// imperative orchestration (spawn + flipCard + recompute). This module
// only owns the predicates the front-face passive needs.
//
// The "is this your first turn?" check lives at the call site in
// GameBoard. It's a single read against `state.turnNumbers[controller]`
// and doesn't warrant its own helper.

const DRUID_ID = 'sorcery-druid';

/**
 * Find the controller's Druid avatar IF it's on the front face. Returns
 * null when the controller has no Druid, or when the Druid has been
 * flipped (`faceDown === true`). The front-face Tawny passive does
 * not apply once the back-face aura is active.
 *
 * @param {Iterable<[any, { userData: { cardInstance } }]>} meshes
 * @param {boolean} controllerRotated  matches `card.rotated` (false = p1, true = p2)
 */
export function findControllerDruidFrontFace(meshes, controllerRotated) {
  if (!meshes) return null;
  for (const [, mesh] of meshes) {
    const card = mesh?.userData?.cardInstance;
    if (!card || card.cardId !== DRUID_ID) continue;
    if (!!card.rotated !== !!controllerRotated) continue;
    if (card.faceDown) continue;
    return card;
  }
  return null;
}
